import { createGenericSlice, DjangoModel } from '@store/slices/generic.slice'
import { createSelector, EntityId } from '@reduxjs/toolkit'
import { RootState } from '@store/store'
import { slotExtraReducers } from '@store/reducres/slot.reducers'

export const timeslotUrl = 'time-slot'

export interface TimeslotModel extends DjangoModel {
  position: string
  broadcastId: EntityId
  newsId: EntityId | null
  jingleId: EntityId | null
}

const {
  slice: timeslotSlice,
  thunks: timeslotThunks,
  adapter: timeslotAdapter,
  selectors,
} = createGenericSlice<TimeslotModel>(
  'timeslot',
  timeslotUrl,
  {},
  slotExtraReducers
)

export const timeslotAdapterExport = timeslotAdapter

export const { selectAll: selectAllSlots, selectById: selectSlotById } =
  timeslotAdapter.getSelectors<RootState>((state: RootState) => state.timeslot)

export const {
  fetchAll: fetchAllTimeslots,
  fetchById: fetchTimeslotById,
  update: updateTimeSlot,
  create: createTimeslot,
  delete: deleteTimeslot,
} = timeslotThunks
export const {
  selectLoading: selectTimeslotLoading,
  selectIsIdInProgress: selectIsTimeslotIdInProgress,
  selectError: selectTimeslotError,
  selectByIds: selectTimeslotsByIds,
} = selectors

export default timeslotSlice.reducer
